<template>
  <div class="pagoda-layout-v2">
    <div
      class="pagoda-layout-v2__submenu"
      :class="{active: subMenuActive}"
      @mouseleave="handleHideMenu"
      @mouseenter="handleShowMenu"
    >
      <!--<div class="pagoda-layout-v2__submenu-title">{{subMenu.title}}</div>-->
      <div class="pagoda-layout-v2__submenu-subtitle">
        <i class="dot"></i>
        <span>{{subMenu.title}}</span>
      </div>
      <ul
        class="pagoda-layout-v2__submenu-list"
        @click="subMenuActive = false"
      >
        <li
          v-for="(subMenuItem, idx) in subMenu.data"
          :key="subMenuItem.label"
          :class="{active: activeSubMenu === subMenuItem}"
          @click="$emit('select-top-menu', subMenuItem)"
        >
          <i
            v-if="subMenuItem.icon"
            class="submenu-icon"
            :class="subMenuItem.icon"
          ></i>
          <img
            v-else-if="subMenuItem.img"
            :src="subMenuItem.img"
            class="submenu-img"
          />
          <i
            v-else-if="subMenuItem.defaultIcon"
            class="submenu-default-icon"
            :style="{
              backgroundColor: defaultIconColors[(idx % defaultIconColors.length)]
            }"
          >{{subMenuItem.label[0]}}</i>
          <span class="submenu-label">{{subMenuItem.label}}</span>
        </li>
      </ul>
      <slot :name="`${subMenu.key}-after-menu`" />
    </div>
    <div class="pagoda-layout-v2__left-menu">
      <div class="top-area">
        <div
          class="logo"
          @click="$emit('logo-click')"
        >
          <img
            v-if="logoImg"
            :src="logoImg"
          />
          <i
            v-else
            :class="[logo]"
          ></i>
        </div>
        <slot name="before-top-menu" />
        <ul class="menu-list">
          <li
            v-for="menuItem in topMenu"
            :key="menuItem.label"
            class="menu-item"
            :class="{active: activeTopMenu === menuItem}"
            @mouseenter="handleMenuMouseenter($event, menuItem)"
            @mouseleave="handleHideMenu"
            @click="!menuItem.subMenu && $emit('select-top-menu', menuItem)"
          >
            <i
              class="menu-item__icon"
              :class="menuItem.icon"
            ></i>
            <div class="menu-item__label">{{menuItem.label}}</div>
          </li>
        </ul>
        <slot name="after-top-menu" />
      </div>
      <div class="bottom-area">
        <slot name="before-bottom-menu" />
        <ul class="menu-list">
          <el-tooltip
            v-for="menuItem in bottomMenu"
            :key="menuItem.icon"
            class="menu-item"
            effect="light"
            :content="menuItem.label"
            placement="right"
          >
            <li
              @click="$emit('select-bottom-menu', menuItem)"
              :class="{active: activeBottomMenu === menuItem}"
            >
              <i
                class="menu-item__icon"
                :class="menuItem.icon"
              ></i>
            </li>
          </el-tooltip>
        </ul>
        <slot name="after-bottom-menu" />
        <div
          class="user"
          @click="handlePersonalMenuToogleVisible"
        >
          <el-tooltip
            v-if="userHead.tooltip"
            v-model="userHeadTooltipVisible"
            effect="light"
            :content="userHead.tooltip"
            placement="right"
          >
            <div>
              <img
                v-if="userHead.src"
                class="user-head"
                :src="userHead.src"
              />
              <i
                v-else
                class="user-head iconfont icon-touxiang"
              ></i>
            </div>
          </el-tooltip>
          <template v-else>
            <img
              v-if="userHead.src"
              class="user-head"
              :src="userHead.src"
            />
            <i
              v-else
              class="user-head iconfont icon-touxiang"
            ></i>
          </template>
          <div
            class="personal-setting-menu"
            v-if="personalSettingMenu.length"
            v-show="personalSettingMenuVisible"
            :style="{bottom: personalSettingMenu.length === 1 ? '24px' : '0'}"
          >
            <div
              class="personal-setting-menu__triangle"
              :style="{
                bottom: personalSettingMenu.length === 1 ? '50%' : '36px',
                transform: personalSettingMenu.length === 1 ? 'translateY(50%)' : 'none'
              }"
            ></div>
            <div
              v-for="menuItem in personalSettingMenu"
              :key="menuItem.label"
              class="personal-setting-menu__item"
              @click="$emit('select-personal-setting-menu', menuItem)"
            >
              <i
                class="personal-setting-menu__icon"
                :class="menuItem.icon"
              ></i>
              <span class="personal-setting-menu__label">{{menuItem.label}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="pagoda-layout-v2__main"
      :class="{'has-header': hasHeader}"
    >
      <div class="pagoda-layout-v2__content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { getEmptyArray, getEmptyObject } from '../../../utils'
import { getMathUrlCollection } from '../../../utils/url'

export default {
  name: 'LayoutV2',
  props: {
    logo: {
      type: String,
      default: 'iconfont icon-jichu'
    },
    logoImg: String,
    topMenu: {
      type: Array,
      default: getEmptyArray
    },
    bottomMenu: {
      type: Array,
      default: getEmptyArray
    },
    userHead: {
      type: Object,
      default: getEmptyObject
    },
    personalSettingMenu: {
      type: Array,
      default: getEmptyArray
    }
  },
  provide() {
    return {
      layoutInstance: this
    }
  },
  data() {
    return {
      hasHeader: false,
      personalSettingMenuVisible: false,
      userHeadTooltipVisible: false,
      subMenuActive: false,
      subMenu: {},
      activeSubMenu: '',
      activeTopMenu: '',
      activeBottomMenu: ''
    }
  },
  created() {
    this.defaultIconColors = ['#FFB400', '#8AC939', '#39C9C7', '#DA5F4F']
  },
  mounted() {
    document.body.addEventListener(
      'click',
      () => {
        this.personalSettingMenuVisible = false
      },
      false
    )
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.setDefaultActive()
      }
    },
    topMenu() {
      this.setDefaultActive()
    },
    bottomMenu() {
      this.setDefaultActive()
    }
  },
  methods: {
    setDefaultActive() {
      const fullPath = this.$route.fullPath.split('?')[0]
      const mathUrlCollection = getMathUrlCollection(fullPath)
      this.activeBottomMenu = null
      this.activeTopMenu = null
      this.activeSubMenu = null

      for (const bottomMenuItem of this.bottomMenu) {
        const _mathUrlCollection = bottomMenuItem.pathMatchFull ? [fullPath] : mathUrlCollection

        if (_mathUrlCollection.includes(bottomMenuItem.url)) {
          this.activeBottomMenu = bottomMenuItem
          return
        }
      }

      for (const topMenuItem of this.topMenu) {
        const _mathUrlCollection = topMenuItem.pathMatchFull ? [fullPath] : mathUrlCollection

        if (!topMenuItem.subMenu && _mathUrlCollection.includes(topMenuItem.url)) {
          this.activeTopMenu = topMenuItem
          return
        } else if (
          topMenuItem.subMenu &&
          topMenuItem.subMenu.data &&
          topMenuItem.subMenu.data.length
        ) {
          for (const subMenuItem of topMenuItem.subMenu.data) {
            if (_mathUrlCollection.includes(subMenuItem.url)) {
              this.activeTopMenu = topMenuItem
              this.activeSubMenu = subMenuItem
              return
            }
          }
        }
      }
    },
    handlePersonalMenuToogleVisible(e) {
      const target = e.target
      this.userHeadTooltipVisible = false

      if (
        target.tagName === 'I' ||
        target.tagName === 'IMG' ||
        target.className === 'user' ||
        target.className === 'el-tooltip'
      ) {
        e.stopPropagation()
      }

      this.personalSettingMenuVisible = !this.personalSettingMenuVisible
    },
    handleHideMenu() {
      this.hideMenuTimer = setTimeout(() => (this.subMenuActive = false), 200)
    },
    handleShowMenu() {
      clearTimeout(this.hideMenuTimer)
      this.subMenuActive = true
    },
    handleMenuMouseenter(e, menuItem) {
      if (menuItem.subMenu && menuItem.subMenu.data.length) {
        e.stopPropagation()

        this.handleShowMenu()
        this.subMenu = menuItem.subMenu
        this.subMenu.title = menuItem.subMenu.title || menuItem.label
        this.subMenu.data.forEach(subMenu => (subMenu._parent = menuItem))
      }
    }
  }
}
</script>
